/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Methods to unlock accounts */
export enum UnlockMethod {
  TimeBasedAutoUnlock,
  AdminUnlock,
  SelfServiceUnlock,
  MultiFactorUnlock,
  SupervisorUnlock,
}

export type UnlockMethodArgs = UnlockMethod;

export function getUnlockMethodEncoder(): FixedSizeEncoder<UnlockMethodArgs> {
  return getEnumEncoder(UnlockMethod);
}

export function getUnlockMethodDecoder(): FixedSizeDecoder<UnlockMethod> {
  return getEnumDecoder(UnlockMethod);
}

export function getUnlockMethodCodec(): FixedSizeCodec<
  UnlockMethodArgs,
  UnlockMethod
> {
  return combineCodec(getUnlockMethodEncoder(), getUnlockMethodDecoder());
}
